import { getStrategyName } from '@/utils/stratagies'

export function proformaTypeLabel(value, session) {
  const member = session?.me?.activeOrg?.member
  const southern = session?.me?.activeOrg?.southernImpressions
  switch (value) {
    case 'buyHold':
      return getStrategyName('Buy & Hold', member)
    case 'fixFlip':
      return getStrategyName('Fix & Flip', member)
    case 'marketing':
      return southern
        ? getStrategyName('Build to Rent', member)
        : 'End Buyer'
    case 'shortTermRental':
      return getStrategyName('Short Term Rental', member)
    case 'wholesale':
      return getStrategyName('Wholesale', member)
    case 'astroflip':
      return getStrategyName('Astroflip', member)
    default:
      return value || ''
  }
}
